import React, { useMemo } from "react";
import styled from "styled-components";
import { useSignalCategories } from "@/components/analysisModules/TopicClusteringTreeView/SignalCategoriesContext";
import { resolveZones } from "@/components/analysisModules/TopicClusteringTreeView/PrioritiesLayout/zoneStyles";
import { ZONE_ORDER } from "@/components/analysisModules/TopicClusteringTreeView/PrioritiesLayout/CONFIG";
import { ZoneCard } from "./ZoneCard";
import { BlurNoteOverlay } from "@/_self_managed/SM_Dashboard/comps/BlurNoteOverlay";

/**
 * One card per zone above the field: how many sub-topics sit in it and the
 * zone's two-word reading. Click a card to keep only that zone's bubbles
 * on the field; click another to swap, the same one again to clear. The
 * same ZoneCard the zones grid draws, as a toggle, without the share bar.
 *
 *   selected  the zone key on, or null
 *   onToggle  (zone) => void
 *   blurNote  when set, the strip sits blurred and inert behind this note
 *             (with only one period of data there is no momentum, so no
 *             zone to count); blurNoteIcon is the note's phosphor icon
 */
const ZONE_READING = {
  fires: "rising & severe",
  chronic: "steady & severe",
  resolving: "cooling & severe",
  emerging: "rising, low",
  background: "steady, low",
  fading: "cooling, low",
};

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
`;

export const ZoneStatsBar = ({ items, selected, onToggle, blurNote, blurNoteIcon }) => {
  const categoryTheme = useSignalCategories();
  const zones = resolveZones(categoryTheme.prioritiesCopy);
  const countByZone = useMemo(() => {
    const out = {};
    for (const item of items) if (item.zone) out[item.zone] = (out[item.zone] || 0) + 1;
    return out;
  }, [items]);
  return (
    <BlurNoteOverlay note={blurNote} icon={blurNoteIcon}>
      <Row role="group" aria-label="Zones">
        {ZONE_ORDER.map((zone) => (
          <ZoneCard
            key={zone}
            zone={zones[zone]}
            count={countByZone[zone] || 0}
            caption={ZONE_READING[zone]}
            selected={selected === zone}
            onClick={() => onToggle(zone)}
          />
        ))}
      </Row>
    </BlurNoteOverlay>
  );
};
